<template>
  <tbody :class="[showDetail ? 'isActive' : '', 'tbody']" v-if="trip">
    <tr>
      <td @click="showDetail = !showDetail">{{ trip.feedbackForStr }}</td>
      <td @click="showDetail = !showDetail">{{ trip.title }}</td>
      <td @click="showDetail = !showDetail">
        {{ trip.userName + trip.userTypeStr }}
      </td>
      <td @click="showDetail = !showDetail">
        {{ trip.factor ? trip.factor.rating : "" }}
      </td>
      <td @click="showDetail = !showDetail">
        {{ trip.time | moment("HH:mm DD MMM") }}
      </td>
      <td @click="showDetail = !showDetail">
        {{ trip.factor && trip.factor.liked ? trip.factor.liked.length : "0" }}
      </td>
      <td @click="showDetail = !showDetail">
        {{
          trip.factor && trip.factor.disliked
            ? trip.factor.disliked.length
            : "0"
        }}
      </td>
    </tr>
    <tr v-if="showDetail && false" style="background-color: #e0f2f1">
      <td colspan="12">
        <table style="width: 100%">
          <tr>
            <td colspan="4" style="width: 35%"></td>
            <td colspan="4" style="width: 35%"></td>
            <td colspan="2" style="width: 15%">
              <small
                class="text-body-2"
                v-for="(likes, key) in trip.factor.liked"
                :key="'likes' + key"
              >
                {{ likes }}
                <br />
              </small>
            </td>
            <td colspan="2" style="width: 15%">
              <small
                class="text-body-2"
                v-for="(likes, key) in trip.factor.disliked"
                :key="'disliked' + key"
              >
                {{ likes }}
                <br />
              </small>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doGet, doPost } from "@/store/common/module/apis";

@Component({
  name: "AccessRow",
  props: {
    value: {
      default: null,
    },
  },
})
export default class AccessRow extends Vue {
  trip = null;
  showDetail = false;

  mounted() {
    if (this.value) this.trip = this.value;
  }

  @Watch("value")
  onValueChange(val) {
    this.trip = val;
  }
}
</script>


<style scoped>
.tbody {
  height: 30px;
}
.tbody tr td {
  padding: 0 2px !important;
  cursor: pointer;
}

.tbody tr td .v-input--checkbox {
  padding: 0;
  height: 30px;
  margin-top: 8px;
}

.isActive,
.isActive:hover {
  background-color: #b2dfdb !important;
}
</style>